import { Badge, Banner, BlockStack, Button, CalloutCard, FooterHelp, Grid, Icon, InlineStack, Link, Page, Text } from '@shopify/polaris';
import OverviewImage from '../../../Asests/Images/overview.png';
import successFul from '../../../Asests/Images/successFul.png';
import styles from './css/overview.module.css';
import React, { useEffect, useState, Suspense, useRef } from 'react';
import { DI, DIProps } from '../../../Core';
import { RenderHeadersAction } from '../Panel';
import Actions from './Componants/Actions';
import Activities from './Componants/Activities';
import Products from './Componants/Products';
import Orders from './Componants/Orders';
import Guide from './Componants/Guide';
import Feature from './Componants/Feature';
import Subscription from './Componants/Subscription';
// import KnowledgeBase from './Componants/KnowledgeBase';
import Performance from './Componants/Performance';
import { necessaryInfo, getBopisInfo, formatDate, getHiddenCarrierCode } from "./Utils/HelperFunc";
import OverviewSkeleton from './Utils/OverviewSkeleton';
import VideoPlayerModal from './Componants/VideoPlayerModal';
import { AlertMinor, ChevronLeftMinor, ChevronRightMinor, CircleInformationMajor } from '@shopify/polaris-icons';
import TourGuide from './Componants/TourGuide';
const KnowledgeBase = React.lazy(() => import('./Componants/KnowledgeBase'));
import { useSearchParams } from "react-router-dom";
import MultiLangPopover from './Componants/MultiLangPopover';
import { useTranslation } from 'react-i18next';
import { Carousel } from 'antd';
import { Doughnut } from 'react-chartjs-2';
import BusinessPriceFeature from './Componants/BusinessPriceFeature';
import FestiveFeature from './Componants/FestiveFeature';
import FestiveModal from '../Pricing/Componant/FestiveModal';
import MultiLangSupportFeature from './Componants/MultiLangSupportFeature';
import SKUwiseCount from './Componants/SKUwiseCount';
import HeroSection from './Componants/HeroSection';
import ErrorModal from '../Listing Grid/Components/ErrorModal';

export interface OverviewI extends DIProps {
    checkPlanExpiration: () => void
    updatePlanStatus: (type: string) => void
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}
interface timeStampI {
    start: string
    end: string
    title: string
}
interface videoI {
    heading: string
    url: string
    timeStamp: timeStampI[]
}
interface videoDetailsI {
    [key: string]: videoI
}

const Overview = (props: OverviewI) => {
    const { t } = useTranslation();
    const [multiLangPopoverActive, setMultiLangPopoverActive] = useState(true);
    const [searchParams, setSearchParams] = useSearchParams();
    const today = new Date(new Date().setHours(0, 0, 0, 0));
    const [orderCount, setOrderCount] = useState<any>({});
    const [skeleton, setSkeleton] = useState<boolean>(true);
    const [nationalOrders, setNationalOrders] = useState<any>({});
    const [recentShipmentOrders, setRecentShipmentOrders] = useState<any>({});
    const [orderCountLoader, setOrderCountLoader] = useState<boolean>(true);
    const [orderCountUpdateTime, setorderCountUpdateTime] = useState<string>("");
    const [showBannerType, setShowBannerType] = useState<'upload_banner' | 'linking_banner' | 'successful_listing' | ''>("successful_listing");
    const [totalProductCount, setTotalProductCount] = useState<string>("0");
    const [modalURLandHead, setModalURLandHead] = useState<any>({});
    const [active, setActive] = useState(false);
    const [duplicateSkuFlag, setDuplicateSkuFlag] = useState(false)
    const [productLinkingStatus, setProductLinkingStatus] = useState({
        close_matched: 0,
        not_linked: 0,
        linked: 0,
    })
    const [showCarrierCodeBanner, setShowCarrierCodeBanner] = useState<any>({
        show: false,
        data: {}
    });
    const [showBanner, setShowBanner] = useState<boolean>(true);
    const [importProductLoader, setImportProductLoader] = useState(false);
    const [productsImporting, setProductsImporting] = useState(false);
    const [shipmentError, setShipmentError] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(1);
    const carouselRef: any = useRef();

    // useEffect(() => {
    //     if (searchParams?.size > 0 && searchParams.getAll('message').length > 0 && searchParams.getAll('success').length > 0) {
    //         let message = searchParams.getAll('message')
    //         let success: any = searchParams.getAll('success')
    //         success == 0 ? props.error(t(message[0])) : props.success(t(message[0]))
    //     }
    // }, [])

    const videoDetails: videoDetailsI = {
        "upload_video": {
            heading: t('How to upload multiple products via the CedCommerce Amazon Channel'),
            url: "qs0C951S-tA",
            timeStamp: [
                {
                    start: '00',
                    end: '10',
                    title: t("Intro")
                },
                {
                    start: '10',
                    end: '25',
                    title: t("Add new template")
                },
                {
                    start: '25',
                    end: '32',
                    title: t("Fill in the template details")
                },
                {
                    start: '32',
                    end: '44',
                    title: t("Filter products")
                },
                {
                    start: '55',
                    end: '75',
                    title: t("Upload via template")
                },
                {
                    start: '75',
                    end: '86',
                    title: "Outro"
                }
            ]
        },
        "liking_video": {
            heading: t('How to link an Existing product via CedCommerce Amazon Channel'),
            url: "7Olft4znKDM",
            timeStamp: [
                {
                    start: '00',
                    end: '12',
                    title: t("Intro")
                },
                {
                    start: '15',
                    end: '42',
                    title: t("Link a Product")
                },
                {
                    start: '42',
                    end: '52',
                    title: t("View Linked Product")
                },
                {
                    start: '52',
                    end: '59',
                    title: t("Outro")
                }
            ]
        },
    }

    const productImport = async () => {
        let queuedTasks: any = [];
        let error: string = ''
        setImportProductLoader(true);
        let response = await props.di.GET("connector/get/allQueuedTasks");
        setImportProductLoader(false);
        if (response?.success) {
            queuedTasks = response?.data?.rows;
        }
        queuedTasks?.map((task: any) => {
            if (task?.marketplace == "shopify" && task?.shop_id == props?.redux?.current?.source?.['_id'] && task?.process_code == "saleschannel_product_import") {
                error = t("template can't be created");
            }
        });
        if (error) {
            setProductsImporting(true);
        }
    }

    useEffect(() => {
        if (searchParams?.size > 0 && searchParams.getAll('message').length > 0 && searchParams.getAll('success').length > 0) {
            let message = searchParams.getAll('message')
            let success: any = searchParams.getAll('success')
            success == 0 ? props.error(t(message[0])) : props.success(t(message[0]))
        }
        props.di.GET("connector/product/getRefineProductCount").then((data: any) => data?.success ? setTotalProductCount(data?.data?.count) : props.error(t(data?.message)));
        getCount();
        getConfig();
        getMatchStatusCount();
        checkForDuplicateSKUExists();
        productImport();
        if (props.di.globalState.get("trial_plan_active")) {
            props.success(t(props.di.globalState.get("trial_plan_active") ?? '') || t("something went wrong"))
            props.di.globalState.removeLocalStorage("trial_plan_active")
        }
    }, [])

    const saveConfig = (value: boolean) => {
        props.di.POST('connector/config/saveConfig', {
            "data": [
                {
                    "group_code": "tutorial_banner",
                    "data": {
                        showSuccessfulBanner: value
                    }
                }
            ],
            "source": {
                "shopId": props?.redux?.current?.source?.['_id'],
                "marketplace": "shopify"
            },
            "target": {
                "shopId": props?.redux?.current?.target?.['_id'],
                "marketplace": "amazon"
            }
        }).then((res: any) => {
            if (!res?.success) props.error(t(res?.message));
            else getConfig();
        })
    }

    const getConfig = () => {
        let counter: number = 0;
        let tempMissingCarrierCodeData: any = {};
        props.di.POST('connector/config/getConfig', {
            "group_code": ["order", "tutorial_banner"]
        }).then((response: any) => {
            if (response?.success) {
                let orderConfig = response?.data?.[0]?.value;
                if (orderConfig?.hasOwnProperty('isSellerEnabledForLocalSelling') && orderConfig?.isSellerEnabledForLocalSelling) {
                    props.di.globalState.set(`isSellerEnabledForLocalSelling`, "true")
                    if (orderConfig?.local_selling_enabled) {
                        // setLocalSellingEnable(true)
                    }
                    else {
                        // setLocalSellingEnable(false)
                    }
                }
                else {
                    // setLocalSellingEnable(false)
                    props.di.globalState.removeLocalStorage(`isSellerEnabledForLocalSelling`);
                }

                if (orderConfig?.hasOwnProperty('shipping_carrier_map') && orderConfig?.shipping_carrier_map === true && orderConfig?.hasOwnProperty('carrier_codes')) {
                    let carrierCodes: any[] = [...orderConfig?.carrier_codes];
                    carrierCodes.forEach((code: any) => {
                        if (code?.amazon_carrier_code === '')
                            counter += 1;
                        tempMissingCarrierCodeData = { ...code }
                    })
                    if (counter > 0) setShowCarrierCodeBanner({ show: true, data: tempMissingCarrierCodeData });
                }

                if (response?.data?.[1]?.value?.hasOwnProperty('showSuccessfulBanner')) {
                    if (showBannerType === 'successful_listing') {
                        setShowBanner(response?.data?.[1]?.value?.showSuccessfulBanner)
                    }
                }
            }
            else props.error(t(response?.message))
        })
    }

    const getCount = async (refresh?: boolean) => {
        setOrderCountLoader(true)
        let obj: any = {};
        let tempNationalOrders: any = {};
        let tempRecentShipmentOrders: any = {};
        obj = {
            "bulk": true,
            "useCache": true,
            "filters": {
                "all_orders_count": {
                    "filter": { ...necessaryInfo(props) }
                },
                "shipped_count": {
                    "filter": { ...necessaryInfo(props), "marketplace_status": { "1": "Shipped" } }
                },
                "cancelled_count": {
                    "filter": { ...necessaryInfo(props), "targets.cancellation_status": { "1": "Cancelled" } }
                },
                "refund_count": {
                    "filter": { ...necessaryInfo(props), "refund_status": { "3": "Refund" } }
                },
                "all_errors_count": {
                    "filter": {
                        ...necessaryInfo(props)
                    },
                    "or_filter": [
                        { "filter": { "targets.status": { "1": "failed" }, "marketplace_status": { "2": "Canceled" }, "targets.order_id": { "10": false } } },
                        // { "filter": { "shipment_error": { "10": true } } },
                        { "filter": { "targets.cancellation_status": { "1": "Failed" } } },
                        { "filter": { "refund_status": { "3": "Failed" } } },
                        {
                            "filter": {
                                "shipment_error": {
                                    "10": true
                                },
                                "marketplace_status": {
                                    "1": "Unshipped"
                                },
                                "attributes.key": {
                                    "1": "Amazon LatestShipDate"
                                },
                                "attributes.value": {
                                    "7": {
                                        "to": "2024-10-11"
                                    }
                                },
                                "pi_removed": {
                                    "10": false
                                },
                                "shipping_status": {
                                    "1": "Unshipped"
                                }
                            }
                        }


                    ]
                },
                "national_failed_orders": {
                    "filter": {
                        ...necessaryInfo(props),
                        "targets.status": { "1": "failed" },
                        "marketplace_status": { "2": "Canceled" },
                        "targets.order_id": { "10": false }
                    }
                },
                "national_failed_shipment": {
                    "filter": {
                        ...necessaryInfo(props), "marketplace_status": {
                            "1": "Unshipped"
                        },
                        "attributes.key": {
                            "1": "Amazon LatestShipDate"
                        },
                        "attributes.value": {
                            "7": {
                                "from": "2024-07-02"
                            }
                        },
                        "pi_removed": {
                            "10": false
                        },
                        "shipment_error": {
                            "10": true
                        },
                        'shipping_status': {
                            "1": "Unshipped"
                        }

                    }
                },
                "national_failed_cancellation": {
                    "filter": { ...necessaryInfo(props), "targets.cancellation_status": { "1": "Failed" } }
                },
                "national_failed_refund": {
                    "filter": { ...necessaryInfo(props), "refund_status": { "3": "Failed" } }
                },
                "shipped_by_today": {
                    "filter": {
                        ...necessaryInfo(props),
                        "marketplace_status": { "1": "Unshipped" },
                        "attributes.key": { "1": "Amazon LatestShipDate" },
                        "attributes.value": {
                            "7": {
                                "from": formatDate(new Date(new Date().setDate(today.getDate()))),
                                "to": formatDate(new Date(new Date().setDate(today.getDate() + 1)))
                            }
                        }
                    },
                    "unwind": "attributes",
                    "or_filter": [
                        { "filter": { "targets.status": { "1": "Created" } } },
                        { "filter": { "shipment_error": { "10": true } } }
                    ]
                },
                "national_failed_return": {
                    "filter": {
                        ...necessaryInfo(props),
                        "targets.return_status": {
                            "1": "Failed"
                        }
                    }
                },
                "shipped_by_tomorrow": {
                    "filter": {
                        ...necessaryInfo(props),
                        "marketplace_status": { "1": "Unshipped" },
                        "attributes.key": { "1": "Amazon LatestShipDate" },
                        "attributes.value": {
                            "7": {
                                "from": formatDate(new Date(new Date().setDate(today.getDate() + 1))),
                                "to": formatDate(new Date(new Date().setDate(today.getDate() + 2)))
                            }
                        }
                    },
                    "unwind": "attributes",
                    "or_filter": [
                        { "filter": { "targets.status": { "1": "Created" } } },
                        { "filter": { "shipment_error": { "10": true } } }
                    ]
                }
            }
        }
        if (refresh) {
            obj['refresh'] = true;
        }
        let response = await props.di.POST('connector/order/getCount', obj);
        console.log(response)
        if (response?.success) {
            setOrderCountLoader(false)
            setorderCountUpdateTime(response?.["cached_at"])
            setOrderCount({
                ...orderCount,
                ...response?.data,
                // errors: response?.data?.national_failed_orders + response?.data?.national_failed_shipment + response?.data?.national_failed_cancellation + response?.data?.national_failed_refund,
                errors: response?.data?.all_errors_count,
                total: response?.data?.all_orders_count
            })
            if (response?.data?.shipped_by_today > 0) tempRecentShipmentOrders['shipped_by_today'] = response?.data?.shipped_by_today;
            if (response?.data?.shipped_by_tomorrow > 0) tempRecentShipmentOrders['shipped_by_tomorrow'] = response?.data?.shipped_by_tomorrow;
            if (response?.data?.ready_for_pickup > 0) tempRecentShipmentOrders['ready_for_pickup'] = response?.data?.ready_for_pickup;
            if (response?.data?.national_failed_return > 0) tempNationalOrders['national_failed_return'] = response?.data?.national_failed_return;
            if (response?.data?.national_failed_orders > 0) tempNationalOrders['failed_order'] = response?.data?.national_failed_orders;
            if (response?.data?.national_failed_cancellation > 0) tempNationalOrders['failed_cancellation'] = response?.data?.national_failed_cancellation;
            if (response?.data?.national_failed_refund > 0) tempNationalOrders['failed_refund'] = response?.data?.national_failed_refund;
            if (response?.data?.national_failed_shipment > 0) {
                tempNationalOrders['failed_shipment'] = response?.data?.national_failed_shipment;
                setShipmentError(true)
            }

            setRecentShipmentOrders({ ...tempRecentShipmentOrders })
            setNationalOrders({ ...tempNationalOrders })
            // setSkeleton(false)
        }
        else props.error(t(response?.message))
    }

    const getMatchStatusCount = () => {
        let temp: any = JSON.parse(JSON.stringify({ ...productLinkingStatus }));
        let DataToSend: any = {
            "target": {
                "marketplace": props.redux.current.target.marketplace,
                "shopId": props.redux.current.target?.['_id']
            },
            "source": {
                "marketplace": props.redux.current.source.marketplace,
                "shopId": props.redux.current.source?.['_id']
            },
        }
        props.di.POST("amazon/product/getMatchStatusCount", DataToSend).then((data: any) => {
            if (data?.success) {
                if (+data?.data?.linked === 0) {
                    if (+data?.data?.not_linked === 0) {
                        setShowBannerType('upload_banner');
                    }
                    else setShowBannerType('linking_banner')
                }
                else setShowBannerType('successful_listing');
                Object.keys(data?.data)?.forEach((key) => {
                    Object.keys(temp)?.forEach((status: any) => status = data?.data?.[status] || 0)
                })
                setProductLinkingStatus({ ...temp })
            }
            else props.error(t(data.message));
        })
    }

    const checkForDuplicateSKUExists = () => {
        props.di.GET('connector/product/checkForDuplicateSKUExists')
            .then((response: any) => {
                if (response?.success) {
                    if (response?.duplicate_sku) {
                        setDuplicateSkuFlag(true);
                    } else {
                        setDuplicateSkuFlag(false);

                    }

                }
                else {
                    props.error(t(response?.message))
                }
                setSkeleton(false)
            })
    }

    const renderBanner = () => {
        if (showBanner)
            return (
                <div className={styles.Custom_Callout__Card}>
                    <CalloutCard
                        title={
                            <InlineStack gap="200" blockAlign='center'>
                                {/* <Text variant="bodySm" as="p" fontWeight='medium'>Step 1/2</Text> */}
                                <Badge progress="incomplete" tone={showBannerType === 'successful_listing' ? 'success-strong' : 'attention'}>
                                    {
                                        showBannerType === 'linking_banner' ?
                                            t("15 products remain unlinked")
                                            :
                                            showBannerType === 'upload_banner' ?
                                                t("No Product listed so far")
                                                :
                                                t("Successfully uploaded a new Product")
                                    }
                                </Badge>
                            </InlineStack>
                        }
                        illustration={showBannerType === 'successful_listing' ? successFul : OverviewImage}
                        primaryAction={{
                            content: showBannerType === 'successful_listing' ? t("Dismiss") : t('Watch Tutorial'),
                            onAction: () => {
                                if (showBannerType === 'upload_banner') {
                                    setModalURLandHead(videoDetails.upload_video)
                                    setActive(true)
                                }
                                else if (showBannerType === 'linking_banner') {
                                    setModalURLandHead(videoDetails.liking_video)
                                    setActive(true)
                                }
                                else {
                                    setShowBanner(false);
                                    saveConfig(false);
                                }
                            }
                        }}
                        secondaryAction={showBannerType === 'successful_listing' ? {
                            content: t('Watch Tutorial Again'),
                            onAction: () => {
                                setModalURLandHead(videoDetails.liking_video)
                                setActive(true)
                            }
                        } : {}}
                    >
                        <InlineStack align='space-between' wrap={false}>
                            <BlockStack gap="300">
                                <BlockStack gap="100">
                                    <Text variant="headingLg" as="h5" tone="success">
                                        {
                                            showBannerType === 'upload_banner' ?
                                                t("Learn to List Products, Before Starting Your Selling Journey on Amazon")
                                                :
                                                showBannerType === 'linking_banner' ?
                                                    t("Learn to Link Unlinked Products, Before Starting Amazon Selling Journey")
                                                    :
                                                    t("Congratulations on your successful Product Listing!")
                                        }
                                    </Text>
                                    <Text variant="headingMd" as="h6" fontWeight='regular' tone="subdued">
                                        {
                                            showBannerType === 'upload_banner' ?
                                                t("View the tutorial and follow the steps to understand how to list new products on Amazon")
                                                :
                                                showBannerType === 'linking_banner' ?
                                                    t("View the tutorial and follow the provided steps to learn how to link unlinked products") :
                                                    t("You can now dismiss this message or keep learning about product listing.")
                                        }
                                    </Text>
                                </BlockStack>
                            </BlockStack>
                        </InlineStack>
                    </CalloutCard>
                </div>
            )
    }
    const goToNextSlide = () => {
        if (carouselRef.current) {
            carouselRef.current.next();
        }
    };
    const goToPrevSlide = () => {
        if (carouselRef.current) {
            carouselRef.current.prev();
        }
    };

    return (
        <React.Fragment>
            {
                skeleton ?
                    <OverviewSkeleton />
                    :
                    <Page
                        title={`${t('Welcome')} ${props.redux.current.source.name ?? props.redux.current.source.username?.split('.myshopify.com')[0]}`}
                        subtitle={t("Find a quick update on all of your crucial operations and activities here including your Product(s) and Order(s) updates.")}
                        primaryAction={<RenderHeadersAction {...props} />}
                    >
                        {/* <ErrorModal/> */}
                        <BlockStack gap="500">
                            {+totalProductCount > 0 && renderBanner()}
                            <Grid columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }}>
                                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}>
                                    <BlockStack gap="500">
                                        {(shipmentError || showCarrierCodeBanner?.show) &&
                                            <BlockStack gap={"050"}>
                                                <div className='custom-carousel-attention-banner'>
                                                    <Carousel
                                                        autoplay={true}
                                                        slidesToShow={1}
                                                        dots={false}
                                                        arrows={false}
                                                        draggable
                                                        infinite={false}
                                                        ref={carouselRef}
                                                        afterChange={(index) => setCurrentSlide(index + 1)}
                                                    >
                                                        {+totalProductCount > 0 &&
                                                            showCarrierCodeBanner?.show &&
                                                            <Banner tone='warning' title={t('Attention is Required')} onDismiss={() => setShowCarrierCodeBanner({ show: false, data: {} })}>
                                                                <BlockStack gap="200" inlineAlign='start'>
                                                                    <Text as='p'>{t("There are mismatched carrier codes between your Shopify and Amazon shipments, which could affect your Amazon Valid Tracking Rate (VTR). Please review and align your carrier code list for accurate tracking.")}</Text>
                                                                    <Button onClick={() => props.history('../config/orderSettings/shipment')}>{t("Map carrier code")}</Button>
                                                                </BlockStack>
                                                            </Banner>
                                                        }
                                                        {shipmentError && <Banner tone='warning' title={t('Attention is Required')} onDismiss={() => setShipmentError(false)}>
                                                            <BlockStack gap="200" inlineAlign='start'>
                                                                <Text as='p'>{t("Some order shipment details failed to sync with Amazon. For more information and to resolve this issue visit shipment error page")}</Text>
                                                                <Button onClick={() => {
                                                                    let tempFilter = {
                                                                        "Status": {
                                                                            "value": "status",
                                                                            "textValue": "",
                                                                            "platform": "",
                                                                            "selectValue": "3",
                                                                            "label": "",
                                                                            "label2": "",
                                                                            "change": false
                                                                        },
                                                                        "Sync Status": {
                                                                            "value": "failed_shipment",
                                                                            "textValue": "true",
                                                                            "selectValue": "10",
                                                                            "label": "Failed Shipment",
                                                                            "change": true
                                                                        },
                                                                        "Price": {
                                                                            "value": "total.price",
                                                                            "textValue": "",
                                                                            "selectValue": "1",
                                                                            "change": false
                                                                        },
                                                                        "Order Date": {
                                                                            "value": "created_at",
                                                                            "start": "",
                                                                            "end": "",
                                                                            "textValue": "",
                                                                            "selectValue": "1",
                                                                            "change": false
                                                                        },
                                                                        "Tags": {
                                                                            "value": "fulfilled_by",
                                                                            "textValue": "",
                                                                            "selectValue": "1",
                                                                            "label": "",
                                                                            "change": false
                                                                        },
                                                                        "Orders": {
                                                                            "from": "",
                                                                            "to": "",
                                                                            "textValue": "",
                                                                            "selectValue": "1",
                                                                            "change": false
                                                                        }
                                                                    }
                                                                    props.di.globalState.set('orders_filter', JSON.stringify(tempFilter))
                                                                    props.history('../allSales')
                                                                }}>{t("Resolve Issue")}</Button>
                                                            </BlockStack>
                                                        </Banner>}
                                                    </Carousel>
                                                </div>
                                                {carouselRef?.current?.innerSlider?.state?.slideCount > 1 &&
                                                    <InlineStack align='space-between'>
                                                        <Button icon={ChevronLeftMinor} variant='monochromePlain' onClick={() => goToPrevSlide()} disabled={currentSlide - 1 === 0} />
                                                        <Text as='p' variant='bodySm' fontWeight='medium'>{currentSlide}/<Text as='span' variant='bodySm' fontWeight='medium' tone='subdued'>{carouselRef?.current?.innerSlider?.state?.slideCount}</Text></Text>
                                                        <Button icon={ChevronRightMinor} variant='monochromePlain' onClick={() => goToNextSlide()} disabled={currentSlide === carouselRef?.current?.innerSlider?.state?.slideCount} />
                                                    </InlineStack>}
                                            </BlockStack>}
                                        {+totalProductCount > 0 && <Actions nationalOrders={nationalOrders} recentShipmentOrders={recentShipmentOrders} />}
                                        <Activities {...props} />
                                        {+totalProductCount > 0 && <Products duplicateSkuFlag={duplicateSkuFlag} totalProductCount={totalProductCount} />}
                                        {+totalProductCount > 0 && <Orders orderCount={orderCount} getCount={getCount} orderCountUpdateTime={orderCountUpdateTime} orderCountLoader={orderCountLoader} />}
                                        <Guide />
                                    </BlockStack>
                                </Grid.Cell>
                                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                                    <BlockStack gap="500">
                                        <HeroSection />
                                        {/* {+totalProductCount > 0 && <MultiLangSupportFeature />} */}
                                        {/* {+totalProductCount > 0 && <Feature />} */}
                                        {/* <BusinessPriceFeature /> */}
                                        {/* {props?.redux?.user_id !== "6475faa1af905c944b0de4f3" ? <FestiveFeature {...props} /> : <BusinessPriceFeature />} */}

                                        <Subscription checkPlanExpiration={props.checkPlanExpiration} updatePlanStatus={props.updatePlanStatus} />
                                        {+totalProductCount > 0 && !importProductLoader && !productsImporting && <TourGuide />}
                                        {+totalProductCount > 0 && <Performance />}
                                        {/* <KnowledgeBase /> */}
                                        <Suspense fallback={<div>{t("Loading KnowledgeBase...")}</div>}>
                                            <KnowledgeBase />
                                        </Suspense>
                                    </BlockStack>
                                </Grid.Cell>
                            </Grid>
                        </BlockStack>
                        <VideoPlayerModal modalURLandHead={modalURLandHead} active={active} setActive={setActive} />
                        <FooterHelp>
                            <InlineStack align="center" gap="100">
                                <div><Icon source={CircleInformationMajor} tone="info" /></div>
                                {t("Learn more about")}
                                <Link target='_blank' url={"https://support.cedcommerce.com/portal/en/kb/articles/overview-26-3-2024"}>{t("CedCommerce Amazon Channel")},</Link>
                                <Link target='_blank' url="https://amazon-sales-channel-app-backend.cifapps.com/Cedcommerce_Privacy_Statement.pdf">{t("Terms & Conditions")}</Link>{' '}
                                {t("and")}
                                <Link target='_blank' url="https://amazon-sales-channel-app-backend.cifapps.com/Data_Privacy_Rights.pdf">{t("Data Privacy Rights")}.</Link>
                                {t("Need Help?")}
                                <Link target='_blank'
                                    url={`https://admin.shopify.com/apps${process.env.REACT_APP_SHOPIFY_APP_BASE}/panel/user/support`}>{t("Get Support")}</Link>
                                {t("or")}
                                <Link target='_blank' url="https://calendly.com/cedcommerce-awe-sales/sales">{t("Book a Call")}</Link>
                            </InlineStack>
                        </FooterHelp>
                    </Page>
            }
        </React.Fragment>
    );
}

export default DI(Overview);

export interface nationalOrdersI {
    "order_fulfilment": {
        "shipped_by_today": number,
        "shipped_by_tomorrow": number
    },
    "failed_order": number,
    "failed_cancellation": number,
    "failed_refund": number,
    "failed_shipment": number,
}

export interface BopisOrdersI {
    [key: string]: number
}